import {MdChevronLeft} from 'react-icons/md'
import PropTypes from 'prop-types'
import BreadcrumbsData from "./Breadcrumbs";
import {Link} from "react-router-dom";


export const HeaderTitle = (props) => {
    return (
        <div className={'py-3'}>
            {(props.breadcrumbLinks) &&
                <BreadcrumbsData home={props.home} links={props.breadcrumbLinks}/>}
            <div className={'d-flex align-items-center'}>
                {props.nav &&
                    <Link to={props.destination}>
                        <MdChevronLeft
                            title={`Przejdź do ${props.destination}`}
                            size={35}
                            className={`${props.size} icon-nav bg-light me-3 link-dark`}/>
                    </Link>
                }
                <div className={`${props.size} d-inline page-heading`}>{props.title}</div>
                <span style={{marginLeft: '1rem'}}>
                        {props.data && props.data.map((item, idx) => {
                            return <span style={{fontSize: "1.75rem"}} key={idx}>
                            <span> {item[0]}: </span>
                            <span>{item[1]}</span>{idx !== props.data.length - 1 && ', '}
                        </span>
                        })}
                    </span>
                {props.extraButton}
            </div>
            {!props.noHr && <hr/>}
        </div>
    )
}


HeaderTitle.propTypes = {
    title: PropTypes.string.isRequired,
    size: PropTypes.string,
    nav: PropTypes.bool,
    destination: PropTypes.string,
    noHr: PropTypes.bool,
    className: PropTypes.string,
    breadcrumbLinks: PropTypes.array, // array of objects with keys: label, to
    home: PropTypes.bool,
    data: PropTypes.array, // [[key, value], [key, value]]
    extraButton: PropTypes.string
}



